import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, Spinner, Badge } from 'react-bootstrap';

const ErroresTarifariosResumen = ({ resumenErrores, loading, onViewDetail, onViewEmpresaDetail }) => {
    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                <Spinner animation="border" />
            </div>
        );
    }

    if (!resumenErrores || (!resumenErrores.tipos_tarifario && !resumenErrores.errores_empresa)) {
        return (
            <div className="text-center">
                <p>No se encontraron datos de errores</p>
            </div>
        );
    }

    const { tipos_tarifario, errores_empresa, total_errores, rango_fecha, tiempo_total } = resumenErrores;

    return (
        <div>
            {/* Información general */}
            <Row className="mb-4">
                <Col md={12}>
                    <Card>
                        <Card.Body>
                            <h5>Resumen General</h5>
                            <Row>
                                <Col md={3}>
                                    <strong>Total de Errores:</strong>
                                    <br />
                                    <Badge bg="danger" className="fs-6">{total_errores}</Badge>
                                </Col>
                                <Col md={4}>
                                    <strong>Rango de Fechas:</strong>
                                    <br />
                                    {rango_fecha?.fecha_inicio} al {rango_fecha?.fecha_fin}
                                </Col>
                                {/* <Col md={3}>
                                    <strong>Tiempo de Análisis:</strong>
                                    <br />
                                    {tiempo_total}
                                </Col> */}
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Cards por tipo de tarifario */}
            <Row>
                {/* Card para errores de empresa */}
                {errores_empresa && (
                    <Col md={6} className="mb-3">
                        <Card 
                            className="h-100 cursor-pointer shadow-sm"
                            style={{ cursor: 'pointer' }}
                            onClick={() => onViewEmpresaDetail()}
                        >
                            <Card.Body className="d-flex flex-column">
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div>
                                        <h5 className="card-title mb-2">
                                            Errores de Empresa
                                        </h5>
                                        <Badge 
                                            bg="info"
                                            className="mb-2"
                                        >
                                            EMPRESA
                                        </Badge>
                                    </div>
                                    <Badge bg="danger" className="fs-5">
                                        {errores_empresa.errores}
                                    </Badge>
                                </div>
                                
                                <div className="mt-auto">
                                    <small className="text-muted mb-1 d-block">
                                        {errores_empresa.descripcion}
                                    </small>
                                    <small className="text-primary">
                                        <i className="bi bi-arrow-right"></i> Hacer clic para ver detalles
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                )}

                {/* Cards por tipo de tarifario existentes */}
                {tipos_tarifario && Object.entries(tipos_tarifario).map(([tipoId, tipoData]) => (
                    <Col md={6} key={tipoId} className="mb-3">
                        <Card 
                            className="h-100 cursor-pointer shadow-sm"
                            style={{ cursor: 'pointer' }}
                            onClick={() => onViewDetail(tipoId)}
                        >
                            <Card.Body className="d-flex flex-column">
                                <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div>
                                        <h5 className="card-title mb-2">
                                            {tipoData.descripcion}
                                        </h5>
                                        <Badge 
                                            bg={tipoData.tipo === 'ingreso' ? 'success' : 'warning'}
                                            className="mb-2"
                                        >
                                            {tipoData.tipo.toUpperCase()}
                                        </Badge>
                                    </div>
                                    <Badge bg="danger" className="fs-5">
                                        {tipoData.errores}
                                    </Badge>
                                </div>
                                
                                <div className="mt-auto">
                                    {/* <small className="text-muted">
                                        <strong>Tiempo de análisis:</strong> {tipoData.tiempo_analisis}
                                    </small>
                                    <br /> */}
                                    <small className="text-primary">
                                        <i className="bi bi-arrow-right"></i> Hacer clic para ver detalles
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            {(!tipos_tarifario || Object.keys(tipos_tarifario).length === 0) && !errores_empresa && (
                <div className="text-center">
                    <Card>
                        <Card.Body>
                            <h5 className="text-success">¡Excelente!</h5>
                            <p>No se encontraron errores en el sistema de tarifarios.</p>
                        </Card.Body>
                    </Card>
                </div>
            )}
        </div>
    );
};

ErroresTarifariosResumen.propTypes = {
    resumenErrores: PropTypes.object,
    loading: PropTypes.bool,
    onViewDetail: PropTypes.func.isRequired,
    onViewEmpresaDetail: PropTypes.func.isRequired
};

export default ErroresTarifariosResumen;
